import React from "react";
import StyledValue from "./StyledValue";

function format(number) {
    const plusPrefix = number > 0 ? "+" : "";
    return plusPrefix + Math.round(number).toLocaleString();
}

export default function MonetaryAmount(props) {
    if (props.amount === null) {
        return <div className="t-monetary-amount">&mdash;</div>
    }
    return <StyledValue value={props.amount} className="t-monetary-amount">{format(props.amount)}</StyledValue>
}